<template>
  <v-dialog
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template
      v-for="(_, name) in $scopedSlots"
      #[name]="slotData"
    >
      <slot
        :name="name"
        v-bind="slotData || {}"
      />
    </template>
  </v-dialog>
</template>

<script>
export default {
  name: "EkitabuDialog",
  inheritAttrs: false,
};
</script>
